import { IAiPendingStatuses } from '@diana/core';
import create from 'zustand';
import {
  BuilderConfigureEditorTabEnum,
  BuilderTypeEnum,
  IFlowBuilder2PageStore,
} from './FlowBuilder2PageStore.types';
import { union } from 'lodash';

const defaultAiPendingStatuses: IAiPendingStatuses = { flows: [], layouts: [] };
const defaultTaskActionIndex = -1;

const initialState = {
  activeTaskId: null,
  activeComponent: null,
  collapsedTasksMap: {},
  isScrollingDndDragItem: false,
  layoutDndDragItem: null,
  layoutDndPlaceholderLocation: null,
  activeModal: null,
  draftInView: [],
  isScrolling: false,
  aiPendingStatuses: defaultAiPendingStatuses,
  rightDrawerActiveTab: BuilderConfigureEditorTabEnum.Configuration,
  leftDrawerActiveTab: null,
  builderType: BuilderTypeEnum.Nocode,
  taskActionIndex: defaultTaskActionIndex,
};

export const useFlowBuilder2PageStore = create<IFlowBuilder2PageStore>((setState, getState) => ({
  ...initialState,
  setActiveTaskId: (activeTaskId) => {
    setState({ activeTaskId, activeComponent: null, taskActionIndex: defaultTaskActionIndex });
  },

  getActiveComponent: () => {
    const { activeComponent } = getState();
    return activeComponent;
  },
  setActiveComponent: (activeComponent) => {
    setState({ activeComponent, activeTaskId: null });
  },
  resetActiveContext: () => setState({ activeTaskId: null, activeComponent: null }),

  setTaskCollapsed: (taskId, collapsed) => {
    const { collapsedTasksMap } = getState();
    const updatedCollapsedTasksMap = { ...collapsedTasksMap };
    if (collapsed) updatedCollapsedTasksMap[taskId] = true;
    else delete updatedCollapsedTasksMap[taskId];
    setState({ collapsedTasksMap: updatedCollapsedTasksMap });
  },

  setIsScrollingDndDragItem: (isScrollingDndDragItem) => setState({ isScrollingDndDragItem }),

  getLayoutDndDragItem: () => getState().layoutDndDragItem,
  setLayoutDndDragItem: (dragItem) => setState({ layoutDndDragItem: dragItem }),

  getLayoutDndPlaceholderLocation: () => getState().layoutDndPlaceholderLocation,
  setLayoutDndPlaceholderLocation: (location) =>
    setState({ layoutDndPlaceholderLocation: location }),

  setActiveModal: (activeModal) => setState({ activeModal }),

  reset: () => setState({ ...initialState }),

  setDraftInView: (draftInView) => setState({ draftInView }),
  addDraftInView: (layoutId) =>
    setState((prev) => ({
      draftInView: prev.draftInView.includes(layoutId)
        ? prev.draftInView
        : [...prev.draftInView, layoutId],
    })),
  removeDraftInView: (layoutId) =>
    setState((prev) => ({
      draftInView: prev.draftInView.filter((id) => id !== layoutId),
    })),
  setIsScrolling: (isScrolling) => setState({ isScrolling }),

  setAiPendingStatuses: (newStatuses) =>
    setState((prev) => ({
      aiPendingStatuses: {
        flows: union(prev.aiPendingStatuses.flows, newStatuses.flows),
        layouts: union(prev.aiPendingStatuses.layouts, newStatuses.layouts),
      },
    })),
  resetEditPending: () =>
    setState({
      aiPendingStatuses: defaultAiPendingStatuses,
      draftInView: [],
    }),
  hasAnyPendingStatus: () => {
    const { aiPendingStatuses } = getState();
    const { flows, layouts } = aiPendingStatuses;

    if (flows.length > 0) return true;
    if (layouts.length > 0) return true;

    return false;
  },

  setRightDrawerActiveTab: (rightDrawerActiveTab) => setState({ rightDrawerActiveTab }),
  setLeftDrawerActiveTab: (leftDrawerActiveTab) => setState({ leftDrawerActiveTab }),
  setBuilderType: (builderType) => setState({ builderType }),
  setTaskActionIndex: (taskActionIndex) => setState({ taskActionIndex }),
}));
